import React from 'react';
import { parseISO } from 'date-fns';
import styled, { css } from 'styled-components';
import { Box, InfoBanner, TextButton } from '@sparknz/spark-pattern-library';
import { LinkRegion } from '@sparknz/tracking';

import { DateFormat, formatDateTime } from 'shared/utils';

const ImportantLink = styled(TextButton)`
  ${({
    theme: {
      palette: { importantSecondary },
    },
  }) => css`
    color: ${importantSecondary};
  `}
`;

interface PreOrderProps {
  onClickLink: () => void;
  releaseDate: string;
  preOrderable: boolean;
}

const PreOrderBanner = ({
  releaseDate,
  preOrderable,
  onClickLink,
}: PreOrderProps) => {
  return preOrderable ? (
    <Box mb="s4">
      <InfoBanner iconName="calendar_small" variant="IMPORTANT">
        {`Pre-order now to receive it from ${formatDateTime(
          parseISO(releaseDate),
          DateFormat.FULL_DATE_SPACE_SEPARATED,
        )}.`}
        <div>
          <LinkRegion regionId="preOrderTab" enableCloning>
            <ImportantLink
              title="Pre-order learn more"
              type="button"
              variant="textbutton"
              onClick={onClickLink}
            >
              Learn more
            </ImportantLink>
          </LinkRegion>
        </div>
      </InfoBanner>
    </Box>
  ) : null;
};
export default PreOrderBanner;
